import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";
import { works } from "@/mocks/works";

export default function NewReleases() {
  const newWorks = works.filter((w) => w.type === "new").sort((a, b) => b.score - a.score);
  const featured = newWorks[0];
  const rest = newWorks.slice(1, 5);

  return (
    <section className="border-y border-background-300/40 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <SectionTitle
          eyebrow="本季热播"
          title="新番速递"
          desc="最新一季口碑新番陆续上线，连载进度实时更新，喜欢的就点进去看个究竟。"
          moreTo="/category/new"
        />

        <div className="grid gap-6 lg:grid-cols-5">
          <Link
            to={`/works/${featured.id}`}
            className="group relative overflow-hidden rounded-2xl ring-1 ring-background-300/60 lg:col-span-3"
          >
            <img
              src={featured.image}
              alt={`${featured.title} 本周新番推荐`}
              title={`${featured.title} - 本周必看新番`}
              className="h-80 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105 md:h-[420px]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/40 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <div className="mb-2 flex flex-wrap items-center gap-2">
                <span className="rounded-full bg-primary-500 px-2.5 py-0.5 text-xs font-bold text-background-50">本周精选</span>
                <span className="rounded-full bg-background-100/70 px-2.5 py-0.5 text-xs text-foreground-700">
                  {featured.category} · {featured.episodes}
                </span>
                <span className="flex items-center gap-1 rounded-full bg-background-100/70 px-2.5 py-0.5 text-xs font-bold text-secondary-400">
                  <i className="ri-star-fill" /> {featured.score.toFixed(1)}
                </span>
              </div>
              <h3 className="font-heading text-2xl text-foreground-950 md:text-3xl">{featured.title}</h3>
              <p className="mt-2 line-clamp-2 max-w-lg text-sm text-foreground-600">{featured.description}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-primary-400 group-hover:text-secondary-400">
                立即查看 <i className="ri-arrow-right-line" />
              </span>
            </div>
          </Link>

          <div className="flex flex-col gap-4 lg:col-span-2">
            {rest.map((w, i) => (
              <Link
                key={w.id}
                to={`/works/${w.id}`}
                className="group flex items-center gap-4 rounded-2xl bg-background-50 p-3 ring-1 ring-background-300/50 transition-all hover:ring-primary-500/50"
              >
                <span className="w-8 text-center font-heading text-xl text-foreground-400">{i + 2}</span>
                <img
                  src={w.image}
                  alt={`${w.title} 海报`}
                  title={w.title}
                  className="h-16 w-12 shrink-0 rounded-lg object-cover object-top"
                />
                <div className="min-w-0 flex-1">
                  <h4 className="truncate text-sm font-bold text-foreground-950 group-hover:text-primary-400">
                    {w.title}
                  </h4>
                  <p className="mt-0.5 truncate text-xs text-foreground-500">{w.category}番 · {w.episodes}</p>
                  <p className="mt-1 flex items-center gap-2 text-xs">
                    <span className="font-bold text-secondary-400">{w.score.toFixed(1)} 分</span>
                    <span className="rounded bg-accent-500/20 px-1.5 py-0.5 text-[10px] text-accent-400">连载中</span>
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}